var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogoutLineRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 13.75V15.8333C12.5007 16.7538 11.7545 17.5 10.834 17.5H5.00065C4.08018 17.5 3.33398 16.7538 3.33398 15.8333V4.16667C3.33398 3.24619 4.08018 2.5 5.00065 2.5H10.834C11.7545 2.5 12.5007 3.24619 12.5007 4.16667V6.71875M9.16732 10H17.5007M17.5007 10L15.4173 7.91667M17.5007 10L15.4173 12.0833",
    stroke: "#ED3E47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoutLineRed);
export default __webpack_public_path__ + "static/media/icon_logout_line_red.676a220d769126b57f0976d779c1e1cd.svg";
export { ForwardRef as ReactComponent };